/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEqual from 'lodash/isEqual';
import size from 'lodash/size';
import * as types from '../constants';
import { campingAxios } from '../utils/campingAxios';
import { campingSearchAxios } from '../utils/externalAxios';
import * as utils from '../utils/utils';

export const fetchGateway = (recareaId) => (dispatch) =>
    campingAxios
        .get(`/recareas/${recareaId}`)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const output = utils.transformGatewayFromBackEnd(json.recarea);
            dispatch(utils.requestSuccess(types.GET_GATEWAY, output));
            return Promise.resolve(output);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });

export const fetchGatewaySearch = (recareaId) => (dispatch) => {
    const args = {
        fq: [`entity_id:${recareaId}`, 'entity_type:recarea'],
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (isEqual(size(payload), 0)) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_SEARCH_ERROR,
                        'No search results found.'
                    )
                );
            } else {
                dispatch(utils.requestSuccess(types.GET_GATEWAY_SEARCH, payload.results));
            }
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_SEARCH_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayCampgrounds = (recareaId) => (dispatch) => {
    const args = {
        fq: [
            `parent_asset_id:${recareaId}`,
            'entity_type:campground',
            'campsite_type_of_use:Overnight',
            'campsite_type_of_use:na',
        ],
        size: 300,
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(
                utils.requestSuccess(types.GET_GATEWAY_CAMPGROUNDS, payload.results)
            );
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_CAMPGROUNDS_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayOtherFacilities = (recareaId) => (dispatch) => {
    const args = {
        fq: [`parent_asset_id:${recareaId}`, 'entity_type:facility'],
        size: 500,
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(
                utils.requestSuccess(
                    types.GET_GATEWAY_POINTS_OF_INTEREST,
                    payload.results
                )
            );
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_POINTS_OF_INTEREST_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayPermits = (recareaId) => (dispatch) => {
    const args = {
        fq: [
            `parent_asset_id:${recareaId}`,
            'entity_type:permit',
            'entity_type:vehiclepermit',
        ],
    };

    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(utils.requestSuccess(types.GET_GATEWAY_PERMITS, payload.results));
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_PERMITS_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayTickets = (recareaId) => (dispatch) => {
    const args = {
        fq: [
            `parent_asset_id:${recareaId}`,
            'entity_type:ticketfacility',
            'entity_type:timedentry',
        ],
    };

    const url = utils.urlWithParams(`${process.env.API}/search`, args);

    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(utils.requestSuccess(types.GET_GATEWAY_TICKETS, payload.results));
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_TICKETS_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayDayUse = (recareaId) => (dispatch) => {
    const args = {
        fq: [
            `parent_asset_id:${recareaId}`,
            'campsite_type_of_use:Day',
            'entity_type:campground',
        ],
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(utils.requestSuccess(types.GET_GATEWAY_DAYUSE, payload.results));
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_DAYUSE_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayActivityPasses = (recareaId) => (dispatch) => {
    const args = {
        fq: [`parent_asset_id:${recareaId}`, 'entity_type:activitypass'],
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(
                utils.requestSuccess(types.GET_GATEWAY_ACTIVITY_PASSES, payload.results)
            );
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_ACTIVITY_PASSES_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchGatewayTreePermits = (recareaId) => (dispatch) => {
    const args = {
        fq: [`parent_asset_id:${recareaId}`, 'entity_type:treepermit'],
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(
                utils.requestSuccess(types.GET_GATEWAY_TREE_PERMITS, payload.results)
            );
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_GATEWAY_TREE_PERMITS_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};

export const fetchPointOfInterest = (recareaId) => (dispatch) => {
    const args = {
        fq: [`entity_id:${recareaId}`],
    };
    const url = utils.urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) {
                dispatch(
                    utils.requestFailure(
                        types.GET_POINT_OF_INTEREST_ERROR,
                        'No point of interest results found.'
                    )
                );
            } else {
                dispatch(
                    utils.requestSuccess(types.GET_POINT_OF_INTEREST, payload.results)
                );
            }
            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_POINT_OF_INTEREST_ERROR,
                        error.response.data.error
                    )
                );
            }
            return Promise.resolve(error);
        });
};
